export interface iVariation {
  gallery: string[]
  hash: string
  title: string
  description: string
  in_stock: boolean
  price: number
  image: string
  internal_only?: boolean
  subscription?: SubscriptionPeriod & { _subscription_price: number; _subscription_length: string }
  pa_ep_product_pricing?: {
    label: string
    slug: string
  }
  pa_ep_strength?: {
    label: string
    slug: string
  }
  pa_ep_frequency?: {
    label: string
    slug: string
  }
  pa_ep_brand?: {
    label: string
    slug: string
  }
  pa_ep_quantity?: {
    label: string
    slug: string
  }
}

export type iVariationKey = 'pa_ep_strength' | 'pa_ep_brand' | 'pa_ep_quantity' | 'pa_ep_frequency'

export const titles: Record<iVariationKey, string> = {
  pa_ep_strength: 'What strength do you need?',
  pa_ep_brand: 'Which brand would you prefer?',
  pa_ep_quantity: 'How many would you like?',
  pa_ep_frequency: 'How often would you like your medication delivered?'
}

export type VariationAttribute = {
  label: string
  slug: string
}

export type SubscriptionPeriod = {
  _subscription_period: 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year'
  _subscription_period_interval: string
}
